import type { IconSvgObject } from './types';

const Cancel01Icon: IconSvgObject = [
  ["path", { d: "M18 6L6.00081 17.9992M17.9992 18L6 6.00085", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Cancel01Icon;
